<app-ui>
  <ng-content></ng-content>
</app-ui>
